import { useFormState } from 'react-final-form';
import { useParams } from 'react-router';
import { useRunSyncMutation } from 'src/shared/api/integrations/common';
import { useGetIntegrationDataQuery } from 'src/shared/api/integrations/factorial';
import { getCompany } from '../../../pages/components/integrations2.0/A3/utils';
import { useDispatch } from 'react-redux';
import { toastTypes } from 'src/shared/components/Toast/ToastOptions';
import { addToast } from 'src/old/actions';
import { getIntegrationNameFix, getIsAbleToSync, type Params } from './utils';
import { getIsConnected } from '../../../pages/components/integrations2.0/utils/getIsConnected';

export const useActionsButtons = () => {
  const { values } = useFormState();
  const { data: integrationData, isLoading } = useGetIntegrationDataQuery();
  const [triggerRunSync] = useRunSyncMutation();
  const companyObj = getCompany({ integrationData, companyName: values.subsidiary ?? values.company });
  const dispatch = useDispatch();
  const { integrationName } = useParams<Params>();

  const { subsidiary } = companyObj ?? {};

  const isConnected = getIsConnected({
    isLoading,
    integrationData,
    subsidiary,
    integrationName: getIntegrationNameFix(integrationName)
  });

  const handleTriggerIntegrationSync = async () => {
    if (!subsidiary) return;

    try {
      await triggerRunSync({ subsidiary }).unwrap();
      dispatch(addToast({ ...toastTypes.success }));
    } catch (error) {
      console.error('error');
    }
  };

  return {
    isAbleToSync: getIsAbleToSync({ integrationName, subsidiary, integrationData }),
    isConnected,
    handleTriggerIntegrationSync
  };
};
